import {
  BUNDLED_IMAGE_KEYS,
  type BundledImageKey,
  isBundledImageKey,
} from "@/shared/lib/bundled-assets";

export const EVENT_CATEGORY_LOGO_OPTIONS = [
  {
    key: "assets/perform-logo.png" as const satisfies BundledImageKey,
    labelLo: "Dance Performance",
    labelEn: "ງານສະແດງ / Performance",
    src: BUNDLED_IMAGE_KEYS["assets/perform-logo.png"],
  },
  {
    key: "assets/fanglao-logo-black.png" as const satisfies BundledImageKey,
    labelLo: "Fanglao Studio",
    labelEn: "Studio / Event",
    src: BUNDLED_IMAGE_KEYS["assets/fanglao-logo-black.png"],
  },
] as const;

export type EventCategoryLogoKey = (typeof EVENT_CATEGORY_LOGO_OPTIONS)[number]["key"];

export function isEventCategoryLogoKey(
  value: string | null | undefined,
): value is EventCategoryLogoKey {
  return !!value && isBundledImageKey(value);
}
